import React from "react";
import { type SxProps, type Theme } from "@mui/material/styles";

import { Link as UiLink } from "ui/link";

export type LinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "color"> & {
  /** Chakra parity: opens in a new tab with `rel="noopener noreferrer"`. */
  isExternal?: boolean;
  sx?: SxProps<Theme>;
};

/**
 * For non-router links. Without an `href` it is an action styled as a link, so it renders a `button`:
 * an `<a>` with no `href` is neither focusable nor announced as interactive.
 */
const Link = ({ isExternal = true, href, children, ...rest }: LinkProps) => (
  <UiLink
    data-testid="link"
    size="small"
    underline="hover"
    component={href ? "a" : "button"}
    type={href ? undefined : "button"}
    href={href}
    target={href && isExternal ? "_blank" : undefined}
    rel={href && isExternal ? "noopener noreferrer" : undefined}
    {...rest}>
    {children}
  </UiLink>
);

export default Link;
